import { useSearchParams, Link } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';
import SEO from '@/components/shared/SEO';

export default function ApplicationPage() {
  const [searchParams] = useSearchParams();
  const customerId = searchParams.get('customerid');

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#F0FDF4] via-white to-white flex items-center justify-center px-4" data-testid="application-page">
      <div className="max-w-lg w-full text-center">
        <SEO title="Application Submitted Successfully" description="Your trademark registration request has been submitted. Our specialists will contact you shortly." />
        <div className="w-20 h-20 rounded-full bg-emerald-100 flex items-center justify-center mx-auto mb-6">
          <CheckCircle className="w-10 h-10 text-[#10B981]" />
        </div>
        <h1 className="font-heading font-extrabold text-3xl sm:text-4xl text-[#064E3B] mb-4">
          Thank You!
        </h1>
        <p className="text-slate-600 text-base leading-relaxed mb-3">
          Your request has been submitted successfully. Our trademark specialists will contact you shortly to discuss your needs and next steps.
        </p>
        {customerId && (
          <p className="text-sm text-slate-500 mb-8">
            Reference ID: <span className="font-mono font-semibold text-[#064E3B]">{customerId}</span>
          </p>
        )}
        <Link
          to="/"
          className="inline-flex items-center justify-center bg-[#064E3B] text-white px-8 py-3 rounded-full font-semibold text-sm hover:bg-[#065F46] transition-colors"
          data-testid="application-home-link"
        >
          Return to Home
        </Link>
      </div>
    </div>
  );
}
